import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface ColorPickerProps {
  label: string;
  value?: string | null;
  onChange: (color: string) => void;
}

export function ColorPicker({ label, value, onChange }: ColorPickerProps) {
  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className="flex items-center gap-3">
        <input
          type="color"
          value={value || '#1e3a8a'}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 w-20 rounded-md border cursor-pointer"
        />
        <Input
          type="text"
          value={value || '#1e3a8a'}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#1e3a8a"
          maxLength={7}
          className="flex-1"
        />
        <div
          className="h-10 w-10 rounded-md border"
          style={{ backgroundColor: value || '#1e3a8a' }}
        />
      </div>
    </div>
  );
}
